import { Box, Flex, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CustomText from "../../components/text/CustomText";
import CustomButton from "../../components/buttons/CustomButton";
import CompanyInfo from "./components/CompanyInfo";
import PersonalInfo from "./components/PersonalInfo";
import Documents from "./components/Documents";
import { useCreateExhibitor } from "../../utils/wds.api";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoginData, updateUser } from "../../redux/actions/auth.actions";
import { getCountries, getTypes } from "../../redux/actions/general.actions";
import AboutYou from "./components/AboutYou";

function OnBoarding() {
  const toast = useToast();
  const navigate = useNavigate();

  const dispatch: any = useDispatch();
  const { uid, user } = useSelector((state: any) => state.authUser);

  const createVisitor = useCreateExhibitor();

  const [payload, setPayload] = useState({
    companyName: "",
    jobTitle: "",
    companyEmail: "",
    companyLocation: "",
    companyPhone: "",
    companyAddress: "",
    companyCity: "",
    firstName: "",
    lastName: "",
    personalEmail: "",
    dateOfBirth: "",
    nationality: "",
    personalPhone: "",
    personalCountry: "",
    personalCity: "",
    personalAddress: "",
    type: "",
    profileImg: "",
    documentType: "Passport",
    documentUrls: [],
    interests: [],
    aboutEvent: [],
    domainOfWork: [],
    purposeOfVisit: [],
  });

  const handleUpdateVisitor = () => {
    dispatch(
      updateUser(uid, {
        companyInfo: {
          companyName: payload.companyName,
          jobTitle: payload.jobTitle,
          companyEmail: payload.companyEmail,
          companyLocation: payload.companyLocation,
          companyPhone: payload.companyPhone,
          companyAddress: payload.companyAddress,
          companyCity: payload.companyCity,
        },
        personalInfo: {
          name: payload?.firstName + " " + payload.lastName,
          email: payload.personalEmail,
          dateOfBirth: payload.dateOfBirth,
          nationality: payload.nationality,
          personalPhone: payload.personalPhone,
          personalCountry: payload.personalCountry,
          personalCity: payload.personalCity,
          personalAddress: payload.personalAddress,
        },
        documentUrls: payload.documentUrls,
        documentType: payload.documentType,
        profileImg: payload.profileImg,
        interests: payload.interests,
        aboutEvent: payload.aboutEvent,
        domainOfWork: payload.domainOfWork,
        purposeOfVisit: payload.purposeOfVisit,
        type: payload?.type,
        status: "Pending",
        isPaymentCompleted: false,
        updatedAt: new Date()?.toString(),
        kycHistory: [
          {
            action: "Registration",
            status: "Initiated",
            createdAt: new Date()?.toString(),
            description: "User initiated registration",
            name: payload?.firstName + " " + payload.lastName,
          },
        ],
      })
    );
    navigate("/dashboard");
  };

  useEffect(() => {
    dispatch(getLoginData(uid));
  }, [uid, dispatch]);

  useEffect(() => {
    if (user) {
      if (user?.companyInfo) {
        navigate("/dashboard");
      }
      setPayload({
        ...payload,
        personalEmail: user?.personalInfo?.email || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    dispatch(getTypes());
    dispatch(getCountries());
    // eslint-disable-next-line
  }, []);

  return (
    <Flex flexDir="column" gap="24px">
      <Box
        maxW="1296px"
        w="100%"
        mx="auto"
        mb="24px"
        boxShadow="0px 3px 4px 0px rgba(0, 0, 0, 0.03)"
        p="24px"
        borderRadius="24px"
        border="1px solid #e4e4e4"
      >
        <CustomText
          text="Complete your onboarding"
          size="24px"
          weight="700"
          color="yess.base_black"
        />
        <Box mb="40px" />
        <Flex flexDir="column" gap="24px">
          <CompanyInfo payload={payload} setPayload={setPayload} />
          <PersonalInfo payload={payload} setPayload={setPayload} />
          <AboutYou payload={payload} setPayload={setPayload} />
          <Documents payload={payload} setPayload={setPayload} />
        </Flex>
        <Flex
          borderTop="1px solid #F2F2F2"
          pt="16px"
          justify="end"
          gap="10px"
          mt="20px"
        >
          <CustomButton
            btnTitle="Save"
            maxW="160px"
            bg="yess.secondary_gold"
            isLoading={createVisitor?.isPending}
            onClick={() => {
              if (
                !payload.companyName ||
                !payload.jobTitle ||
                !payload.companyEmail ||
                !payload.companyLocation ||
                !payload.companyPhone ||
                !payload.companyAddress ||
                !payload.companyCity ||
                !payload.firstName ||
                !payload.lastName ||
                !payload.personalEmail ||
                !payload.dateOfBirth ||
                !payload.nationality ||
                !payload.personalPhone ||
                !payload.personalCountry ||
                !payload.personalCity ||
                !payload.personalAddress ||
                payload.documentUrls.length === 0 ||
                !payload?.profileImg
              ) {
                toast({
                  title: "Please fill in all required fields",
                  status: "error",
                  duration: 3000,
                  isClosable: true,
                });
                return;
              }

              handleUpdateVisitor();
            }}
          />
        </Flex>
      </Box>
    </Flex>
  );
}

export default OnBoarding;
